import Mapper from './Mapper';
import { PlatformOperatorResponseDTO } from 'typings/dto/platformOperator';

export default class PlatformOperatorMapper extends Mapper<
  PlatformOperator,
  PlatformOperatorResponseDTO
> {
  constructor() {
    super(
      {
        enterprise: 'enterprise',
        tenant: 'tenant',
      }
    );
  }

  public responseDTOToModel = (dto: PlatformOperatorResponseDTO): PlatformOperator => {
    const outerMappers = this.getOuterMappers();
    return {
      ...this.responseDTOToModelViaDiffMap(dto),
      enterprise: outerMappers.enterprise.responseDTOToModel(dto.enterprise),
      tenant: dto.tenant,
    };
  };
}
